var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"alerts-info-top-bar",attrs:{"fluid":"","grid-list-xl":""}},[_c('div',{staticClass:"patients-info-top",staticStyle:{"text-align":"left"}},[_c('patient-info')],1),_vm._v(" "),_c('div',{staticClass:"alerts-top",staticStyle:{"text-align":"right"}},[_c('assessment-alerts')],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05c4d3d6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/shared/TopBar.vue
// module id = null
// module chunks = 